import camelCase from 'lodash/camelCase';
import { flow, map, keyBy, mapValues, get, getOr, set } from 'lodash/fp';

import { ESTIMATE_LOADED } from './actionTypes';

import tryParseJson from '../utils/tryParseJson';
import fromString from '../utils/fromString';
import getInstallationPricing from './getInstallationPricing';
import getItemsWithPurchaseOptionIn from '../helpers/mandi/getItemsWithPurchaseOptionIn';
import getAttributeCount from '../helpers/getAttributeCount';

const explodeItemAttributes = (item) => {
  const { attributes } = item;

  return {
    ...item,
    attributes: map((attr) => {
      if (tryParseJson(attr.value, attr)) {
        return set(
          'normalizedValue',
          fromString(getOr('', 'normalizedValue')(attr)),
        )(attr);
      }

      return attr;
    })(attributes),
  };
};


const buildCharges = (haulCount, removeCount, adjustmentCount) => ({
  windowHaul: !!haulCount,
  windowHaulCount: haulCount,
  windowRemoval: !!removeCount,
  windowRemoveCount: removeCount,
  windowAdjustment: !!adjustmentCount,
  windowAdjustmentCount: adjustmentCount,
});

const estimateLoaded = designApiResponse => (dispatch, getState) => {
  const loadedItemIds = map('itemId')(designApiResponse.items);
  const existingItems = get('estimateBuilder.entities.items')(getState());

  const { design } = designApiResponse;
  design.attributes = flow(
    keyBy(it => camelCase(it.name)),
    mapValues('value'),
  )(designApiResponse.designAttributes);
  design.attributes.isMandi = (design.attributes.isMandi === 'true');

  const deletedItemIds = existingItems.allIds.reduce((result, itemId) => {
    const item = existingItems.byId[itemId];
    if (item.designId === designApiResponse.design.designId && loadedItemIds.indexOf(itemId) < 0) {
      result.push(itemId);
    }
    return result;
  }, []);

  const payload = {
    ...designApiResponse,
    items: map(explodeItemAttributes)(designApiResponse.items),
    deletedItemIds,
  };

  if (design.attributes.isMandi) {
    // Persist haul away, removal, and adjustment from design items.
    const selectedLeafItems = flow(
      get('items'),
      getItemsWithPurchaseOptionIn(['product-and-install'], design.designId),
      map('itemId'),
    )(designApiResponse);
    const selectedInstallItems = flow(
      get('items'),
      getItemsWithPurchaseOptionIn(['product-and-install'], design.designId),
    )(designApiResponse);
    let extras = {};

    const haulItemsCount = getAttributeCount('windowHaul', selectedInstallItems);
    const removeItemsCount = getAttributeCount('windowRemoval', selectedInstallItems);
    const adjustmentItemsCount = getAttributeCount('windowAdjustment', selectedInstallItems);
    extras = buildCharges(haulItemsCount, removeItemsCount, adjustmentItemsCount);

    dispatch(getInstallationPricing(design.designId, selectedLeafItems, extras, { mode: 'transient' }));
  }

  dispatch({
    type: ESTIMATE_LOADED,
    payload,
  });

  return design;
};
export default estimateLoaded;
